import { useState, useEffect } from 'react';
import { getMediaListURL } from '../utils/ConstantsURL';

export const useGetMediaList = (token) => {
  const [mediaList, setMediaList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMediaList = async () => {
      if (!token) return;
      
      setLoading(true);
      setError(null);
      
      try {
        const response = await fetch(getMediaListURL(), {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`Error ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();
        setMediaList(data || []);
      } catch (error) {
        console.error('Error fetching media list:', error);
        setError(error.message);
        setMediaList([]);
      } finally {
        setLoading(false);
      }
    };

    fetchMediaList();
  }, [token]);

  return {
    mediaList,
    loading,
    error
  };
};
